

































import { Component, Vue, Prop } from "vue-property-decorator"
import { msTimestampFormat } from "@/utils"
import { PolicyInfo } from "./constant"
import { mapGetters } from "vuex"
import config from "@/config"
@Component({
    components: {},
    computed: {
        ...mapGetters(["currentUser", "allUser"]),
        ...mapGetters("common", [
            "productSubTypeMap",
            "areaMap",
            "preparationStatusMap",
            "PolicyStatusMap",
            "syncWayMap",
            "textTypeMap"
        ])
    }
})
export default class PolicyInfoContent extends Vue {
    readonly allUser!: { [uid: string]: any }
    readonly productSubTypeMap: any
    readonly areaMap: any
    readonly preparationStatusMap: any
    readonly syncWayMap: any
    readonly PolicyStatusMap: any
    readonly textTypeMap: any
    readonly policyInfo = PolicyInfo
    @Prop({ type: Object, default: () => ({}) }) info: any
    isShowAll = false

    get detail() {
        const {
            text_type,
            product_sub_type,
            area,
            preparation_status,
            sync_way,
            apply_uid,
            deployer,
            edit_user,
            director,
            next_version_effective_time,
            deploy_time,
            apply_time,
            edit_time
        } = this.info
        return {
            ...this.info,
            area: this.areaMap[area],
            text_type: this.textTypeMap[text_type],
            product_sub_type: this.productSubTypeMap[product_sub_type],
            preparation_status: this.preparationStatusMap[preparation_status],
            sync_way: this.syncWayMap[sync_way],
            apply_uid: this.getNameStr(apply_uid),
            deployer: this.getNameStr(deployer),
            edit_user: this.getNameStr(edit_user),
            director: this.getNameStr(director),
            next_version_effective_time: msTimestampFormat(next_version_effective_time),
            deploy_time: msTimestampFormat(deploy_time),
            apply_time: msTimestampFormat(apply_time),
            edit_time: msTimestampFormat(edit_time)
        }
    }

    getNameStr(arr: number[] | number) {
        if (Array.isArray(arr)) {
            const nameArr = arr.map(uid => {
                return this.allUser[uid]?.name
            })
            return nameArr.join("、")
        } else {
            return arr ? this.allUser[arr]?.name : "-"
        }
    }

    getTextData(arr: any) {
        if (!arr || !Array.isArray(arr) || arr.length === 0) {
            return "-"
        }
        const labels = arr.map(value => {
            return this.productSubTypeMap[value] || "-"
        })
        return labels.join(" | ")
    }

    expandAll() {
        this.isShowAll = true
    }
    retractAll() {
        this.isShowAll = false
    }

    operateLink(key: string) {
        const { product_id, software_id, approval_id, link } = this.detail
        switch (key) {
            case "software_name":
            case "product_name":
                this.$router.push({
                    path: "/manage/product-detail",
                    query: {
                        software_id: String(software_id),
                        product_id: String(product_id)
                    }
                })
                break
            case "approval_id":
                this.onViewApply(approval_id)
                break
            case "link":
                this.openUrl(link)
                break
        }
    }

    openUrl(url: string) {
        if (url) {
            window.open(url)
        }
    }

    onViewApply(approval_id: string) {
        if (!approval_id) {
            return
        }
        const url =
            config.env === "online"
                ? `https://home.intsig.net/process-centric/approval-detail?approval_id=${approval_id}`
                : `https://home-sandbox.intsig.net/process-centric/approval-detail?approval_id=${approval_id}`
        // window.location.href = url
        window.open(url)
    }
}
